var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRateXicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 72.3237L8.24833 56.7496C5.30021 52.5266 3.27957 47.7273 2.31934 42.6674C1.35911 37.6074 1.48103 32.4016 2.6771 27.3921C4.42957 19.5552 8.87104 12.5794 15.2304 7.67578C26.9698 -1.62166 45.6189 -2.67078 56.1645 5.6137L38.2027 27.3198L28.1998 15.49C24.0761 15.2847 19.9433 15.3451 15.8273 15.6708L31.7994 34.9892L0.578842 72.6312L0 72.3237Z",
    fill: "#95C82A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1487 42.6232L49.3274 55.9363H61.7903L44.4797 35.0261L73.4211 0.0974121L73.9999 0.513444L66.0953 14.0074C72.2996 23.0516 74.8501 32.7289 72.5167 43.4372C70.9185 51.1877 66.7346 58.1652 60.6507 63.2259C48.7666 73.2649 30.7506 74.6397 18.6133 66.1019L38.1487 42.6232Z",
    fill: "#95C82A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateXicon);
export default __webpack_public_path__ + "static/media/rateXicon.8c45df8c8f5efa620760c728fb4e333b.svg";
export { ForwardRef as ReactComponent };